/* NZS Alpine health - keeps the storefront usable even if Alpine fails to boot.
   (1) first-error capture (diagnose crashes on the password-gated store),
   (2) blank-page watchdog: if Alpine never initialises, reveal the content it would have shown.
   Loaded early (defer, before vendors.js) from layout/theme.liquid. No deps. */
(function () {
  if (window.__nzsHealth) return; window.__nzsHealth = 1;
  if (window.Shopify && Shopify.designMode) return;   // never touch the theme-editor canvas

  /* NZS-TELEPORT-TRACE-0830: Alpine warns "Cannot find x-teleport element for selector: X"
     when a template[x-teleport]'s destination is missing at init (vendors.js now skips the
     append instead of throwing - NZS-TELEPORT-GUARD-0830). Capture that selector onto
     <html data-nzs-teleportmiss> so the offending template names itself on any page. */
  (function () {
    var warn = console.warn;
    console.warn = function () {
      try {
        var m = String(arguments[0] || '') + ' ' + String(arguments[1] || '');
        if (m.indexOf('x-teleport') !== -1) {
          var prev = document.documentElement.getAttribute('data-nzs-teleportmiss') || '';
          document.documentElement.setAttribute('data-nzs-teleportmiss', (prev + ' || ' + m).slice(-500));
        }
      } catch (e) {}
      return warn.apply(console, arguments);
    };
  })();

  /* (1) record the FIRST error - readable via <html data-nzs-firsterr> even when pw-gated */
  var logged = false;
  var hardErr = false;    // real script/promise error, NOT a benign resource 404
  var rescueTries = 0;
  function note(kind, msg, src, ln, col) {
    if (logged) return; logged = true;
    var s = (kind + ': ' + (msg || '') + (src ? (' @' + src + ':' + (ln || '') + ':' + (col || '')) : '')).slice(0, 300);
    try { document.documentElement.setAttribute('data-nzs-firsterr', s); } catch (e) {}
    try { console.error('[nzs-health] first error:', s); } catch (e) {}
  }
  window.addEventListener('error', function (e) {
    if (e.target === window) hardErr = true;   // resource 404s have e.target = the img/script/link, not window
    note('error', e.message, e.filename, e.lineno, e.colno);
  }, true);
  window.addEventListener('unhandledrejection', function (e) {
    hardErr = true;
    note('promise', (e.reason && e.reason.message) || String(e.reason));
  });

  /* (2) blank-page watchdog - Alpine v3 marks initialised x-data roots with _x_dataStack; the <body>
     carries x-data in this theme, so a missing stack after the window means Alpine never booted. */
  function booted() { return !!(document.body && document.body._x_dataStack); }
  function rescue() {
    if (booted()) return;                              // Alpine fine -> no-op (zero impact on normal loads)
    if (document.hidden) return;                       /* NZS: never rescue a hidden tab (rAF paused -> Alpine boots on focus) */
    if (window.Alpine && !hardErr && rescueTries < 4) { /* NZS: Alpine present + no HARD error -> just slow; wait, don't false-rescue */
      rescueTries++; setTimeout(rescue, 3000); return;
    }
    try {
      document.querySelectorAll('[x-cloak]').forEach(function (el) { el.removeAttribute('x-cloak'); });
      document.querySelectorAll('.anm-move-up').forEach(function (el) { el.classList.add('active-anm-heading'); });
      document.querySelectorAll('.animate_transition_card__image').forEach(function (el) { el.classList.add('active', 'lazy_active'); });
      document.documentElement.setAttribute('data-nzs-rescued', '1');
      try { console.warn('[nzs-health] Alpine did not boot - content revealed by watchdog'); } catch (e) {}
    } catch (e) {}
  }
  /* NZS card image/cloak sweep - ALWAYS runs (even when Alpine DID boot) to catch PARTIAL boots:
     un-cloak collection card slideshows + reveal any card image that loaded but missed its inline onload. */
  /* reveal one card image that finished loading but missed its inline onload (eager/cached/bfcache). */
  function revealImg(im) {
    if (im && im.complete && im.naturalWidth > 0 && im.classList.contains('skeleton-image')) {
      im.classList.remove('animate-Xpulse', 'skeleton-image'); im.classList.add('img-loaded', 'active');
    }
  }
  function cardSweep() {
    try {
      document.querySelectorAll('.card-product [id^="x-slideshow-card-product-"][x-cloak]').forEach(function (el) { el.removeAttribute('x-cloak'); });
      document.querySelectorAll('.card-product img.skeleton-image').forEach(revealImg);
    } catch (e) {}
  }
  /* per-image: catch every card image the instant it loads - eager, lazy-on-scroll, infinite-scroll. */
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.classList.contains('skeleton-image') && t.closest('.card-product')) revealImg(t);
  }, true);
  function arm() { setTimeout(rescue, 3000); setTimeout(cardSweep, 1200); }   // rescue=total-boot-fail; cardSweep=always
  document.addEventListener('visibilitychange', function () {   /* NZS: tab focused -> rAF resumes + Alpine boots; re-check so no false rescue */
    if (document.hidden) return;
    cardSweep();
    if (!booted()) setTimeout(rescue, 1500);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  window.addEventListener('load', cardSweep);
  window.addEventListener('pageshow', cardSweep);   // Back/bfcache restore - no other handler re-fires

  /* (3) alpine:init stub seeder - this file is the FIRST deferred script, so this listener runs
     first when vendors.js dispatches alpine:init. It pre-seeds flags-only stubs for the stores
     whose real registrations have (or had) an rAF race in stock Eurus scripts. A real
     registration later in the same dispatch simply overwrites the stub; if one is ever missed
     again, expressions read inert flags instead of throwing TypeErrors on undefined. */
  document.addEventListener('alpine:init', function () {
    try {
      var A = window.Alpine;
      if (!A || !A.store) return;
      if (!A.store('xQuickView')) {
        var qv = window.xQuickView || {};
        A.store('xQuickView', {
          __nzsStub: true,
          sectionId: qv.sectionId || '',
          enabled: false,
          buttonLabel: qv.buttonLabel || '',
          show_atc_button: !!qv.show_atc_button,
          btn_atc_bottom: !!qv.atc_btn_bottom,
          atc_btn_image_desktop: !!qv.atc_btn_image_desktop,
          show: false,
          loading: false
        });
      }
      /* xScrollTop: Eurus's floating back-to-top ships its markup but its JS was never
         shipped in this build -- every page threw "xScrollTop is not defined". This is the
         whole component, not a dead stub. A real registration later in the same dispatch
         would simply overwrite it. */
      if (A.data) A.data('xScrollTop', function () { return {
        show: false,
        scrollFunction: function () { this.show = (window.scrollY || document.documentElement.scrollTop || 0) > 400; },
        scrollTop: function () { try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); } }
      }; });
      if (!A.store('xCartNoti')) {
        A.store('xCartNoti', {
          __nzsStub: true,
          enable: false,
          listItem: [],
          show: false,
          setItem: function () {},
          open: function () {}
        });
      }
    } catch (e) {}
  });
})();
